import { z } from 'zod';

export const translationStatsSchema = z.object({
  challengeCount: z.number(),
  translatedCount: z.number(),
  translationCount: z.number(),
  byLang: z.record(z.string(), z.number()),
});

export const getTranslationStatsResponseSchema = z.object({
  success: z.literal(true),
  data: translationStatsSchema,
});

export type ITranslationStats = z.infer<typeof translationStatsSchema>;
export type IGetTranslationStatsResponse = z.infer<typeof getTranslationStatsResponseSchema>;
